const SCI = require('sci')

SCI.boot().then(() => {

})



// WEBPACK FOOTER //
// ./resources/assets/javascript/pages/default.js